import { ACCORDION_CLASS_NAME } from '../../constants/mui-components';

const MuiAccordion = {
  styleOverrides: {
    root: {
      [`&.${ACCORDION_CLASS_NAME}`]: {
        backgroundColor: 'transparent',
        '& .MuiAccordionSummary-content': {
          margin: 0,
          width: '100%',
        },
        '&:before': {
          display: 'none',
        },
        '&:after': {
          display: 'none',
        },
      },
    },
  },
};

export default MuiAccordion;
